<div class="at-filter-option" *ngFor="let qBank of questionBanks">
  <div class="d-flex align-items-center justify-content-between w-100">
    <label class="at-radio-container mb-0 flex-grow-1">
      <input type="radio" name="qBankFilter" [value]="qBank" [checked]="isCurrentQBank(qBank)"
        (change)="changeCurrentQBank(qBank)" />
      <span class="at-option-label">
        {{ qBank.name }} {{ qBank.tag?.arabic ? '(' + qBank.tag.arabic + ')' : '' }}
      </span>
    </label>

    <div class="at-action-menu">
      <p-menu #menu
        [model]="(qBank._id == standardQBID || qBank._id == '65be27cc36dfdb71f30f576a' || qBank._id == '65be1be32d7710d9e377d543') ? updateOnlyMenuItem : hasCreatedBy(qBank)"
        [popup]="true" appendTo="body"></p-menu>

      <button class="at-action-btn" (click)="openTypeMenu(menu, $event, qBank)">
        <i class="pi pi-ellipsis-v"></i>
      </button>
    </div>
  </div>
</div>

<!-- Update Data Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="updateModal"
  [style]="{ margin: '0rem 1rem' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{
      "Update Question Bank" | translator
      }}</span>
  </ng-template>
  <app-dynamic-form *ngIf="updateModal" [questions]="updateQuestions"
    (sendData)="UpdateData($event)"></app-dynamic-form>
</p-dialog>

<!-- Create new Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openCreateModal"
  [style]="{ margin: '0rem 1rem',width:'40%' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{"Add Question Bank"| translator}}</span>
  </ng-template>
  <app-dynamic-form [questions]="questions" (sendData)="receiveData($event)"></app-dynamic-form>
</p-dialog>

<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openInfoModal"
  [style]="{ margin: '0rem 1rem', width: '45vw', maxWidth: '1000px' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ "Created By Info" | translator }}</span>
  </ng-template>
  <div class="d-flex gap-1">
    <div>
      <h5 class="medium-h">{{ "Created By Name" | translator }}</h5>
      <input
        type="text"
        [value]="getName(createdInfo?.createdBy?.name)"
        class="p-inputtext"
        [disabled]="true"
      />
    </div>
    <div>
      <h5 class="medium-h">{{ "Created By Email" | translator }}</h5>
      <input
        type="text"
        [value]="createdInfo?.createdBy?.email"
        class="p-inputtext"
        [disabled]="true"
      />
    </div>
    <div>
      <h5 class="medium-h">{{ "Created Time" | translator }}</h5>
      <input
        type="text"
        [value]="createdInfo?.createdAt | date: 'medium'"
        class="p-inputtext"
        [disabled]="true"
      />
    </div>
  </div>
</p-dialog>